export default __webpack_public_path__ + "static/media/project-bloom-logo-light.455acbe2.svg";